export default import.meta.ROLLUP_FILE_URL_Khf0tmt3L8LdVWidKh604g